const Error404 = ({ labels }) => {
  return (
    <div className="error-page">
      <div className="error-page__content">
        <div className="error-page__404">
          <span className="error-page__digit">4</span>
          <span className="error-page__logo error-page__logo--animated" />
          <span className="error-page__digit">4</span>
        </div>
        <h1>
          {labels?.WELFARE_404_TITLE || "Sorry we couldn’t find the page you are looking for."}
        </h1>
        <p>
          {labels?.WELFARE_404_DESCRIPTION ||
            "The link you followed may be broken or the page may have been removed."}
        </p>
        <a href="/" target="_blank" rel="noreferrer" className="link--text">
          <span>{labels?.WELFARE_GO_TO_OEL || "Go to One EssilorLuxottica"}</span>
        </a>
      </div>
    </div>
  );
};

export default Error404;
